import React from 'react';
import { createStyles, Grid, makeStyles, MenuItem, TextField } from '@material-ui/core';
import { Filter } from '../DataGridFilterMenu';
import { ColumnInstance } from 'react-table';
import { useTranslation } from '@fluentsms/i18n';

export type DataGridEnumFilterPropTypes = {
  filter: Filter;
  onFilterChange: (filterValue: Filter) => void;
  columns: ColumnInstance[];
  columnOptions?: string[];
  column?: { retainEnumFilterCasing?: boolean };
};

const useStyles = makeStyles(() =>
  createStyles({
    columnInputLabel: {
      textTransform: 'capitalize',
    },
  }),
);

export const DataGridEnumFilter = ({
  filter,
  onFilterChange,
  columnOptions = [],
  column,
}: DataGridEnumFilterPropTypes): JSX.Element => {
  const classes = useStyles();

  const { t } = useTranslation('common');
  const handleValueChange = (
    e: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    onFilterChange({ ...filter, value: (e.target.value as string) || '' });
  };

  const handleOperatorChange = (
    e: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    onFilterChange({ ...filter, operator: (e.target.value as string) || '' });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <TextField
          id="operator-field"
          value={filter?.operator || ''}
          label={t('operator')}
          InputLabelProps={{
            className: classes.columnInputLabel,
          }}
          onChange={handleOperatorChange}
          data-testid="data-grid-enum-filter-operator-field"
          select
          fullWidth
        >
          <MenuItem value="includes" data-testid="data-grid-enum-filter-operator-option-includes">
            includes
          </MenuItem>
          <MenuItem value="excludes" data-testid="data-grid-enum-filter-operator-option-excludes">
            excludes
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          id="value-field"
          label={t('value')}
          value={filter?.value || ''}
          InputLabelProps={{
            className: classes.columnInputLabel,
          }}
          onChange={handleValueChange}
          data-testid="data-grid-enum-filter-value-field"
          select
          fullWidth
        >
          {columnOptions.map((value, index) => (
            <MenuItem key={`filter-enum-option-${index}`} value={value} data-testid={`filter-enum-option-${index}`}>
              {column?.retainEnumFilterCasing
                ? value
                : value
                    ?.split(/[_-]/)
                    .map((word) => (word.length ? word[0].toUpperCase() + word.substring(1).toLowerCase() : ''))
                    .join(' ')}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};
